import * as React from "react";
import Button from "@mui/material/Button";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
  blackColor,
  defaultFont,
  grayColor,
} from "../../assets/jss/psstyle/psacount";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import ConditionAP from "./Components/ConditionAP";
import ConditionAPSelect from "./Components/ConditionSelectAP";
import ConditionSelectProduct from "./Components/ConditionSelectProduct";
import ConditionARSelect from "./Components/ConditionSelectAR";
import ConditionAR from "./Components/ConditionAR";
import CustomInput from "../CustomInput/CustomInput";
import CustomDateRangePicker from "../CustomDatepicker/CustomDateRangePicker";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}
export default function Condition_recheck(props) {
  const [tabValue, setTabValue] = React.useState(0);
  const [tabData1, setTabData1] = React.useState([]);
  const [tabData2, setTabData2] = React.useState([]);
  const [tabData3, setTabData3] = React.useState([]);
  const [rowList, setRowList] = React.useState(100);
  const tabHandleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const keyDown = (e) => {
    console.log(e);
    if (e === "Enter") {
    }
  };
  const SearchData = (e) => {
    props.resDataConditions([tabData1, tabData2, tabData3, rowList]);
  };

  // end  รับค่าวันที่
  const resultCondition = (provenance, value) => {
    console.log("resultCondition", provenance, "value", value);

    if (provenance === "tab1") {
      setTabData1(value);
    } else if (provenance === "tab2") {
      setTabData2(value);
    } else if (provenance === "tab3") {
      setTabData3(value);
    }
  };
  const setResData = async (e) => {
    await setRowList(null);
    await setRowList(e);
  };

  const resInput = async (source, value) => {
    console.log("resInput", value);
    // if (source === "DocNo") {

    if (source === "docNo") {
      setState({
        ...state,
        ["docNoStart"]: value.docNoStart,
        ["docNoEnd"]: value.docNoEnd,
      });
    } else if (source === "siteCode") {
      setState({
        ...state,
        ["siteCode"]: value,
      });
    } else if (source === "docDate") {
      setState({
        ...state,
        ["dateStart"]: value.docNoStart,
        ["dateEnd"]: value.docNoEnd,
      });
    }
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Grid container spacing={1}>
          <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
            <Button
              variant="outlined"
              startIcon={<SearchRoundedIcon />}
              sx={{
                pt: -5,
                height: "32px",
                mt: 1.4,
                borderColor: grayColor[11],
                color: blackColor[0],
                fontFamily: defaultFont,
              }}
              onClick={() => SearchData()}
              size="small"
            >
              ค้นหา
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomInput
              inputType={"number"}
              id={"rowSelect"}
              label={`จำนวนรายการ`}
              placeholder={
                "ถ้าต้องการรายการทั้งหมดตามเงื่อนไขให้กรอก -1 ค่าเริ่มต้นเป็น 100"
              }
              resData={(e) => setResData(e)}
            />
          </Grid>
        </Grid>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={tabHandleChange}
            aria-label="basic tabs example"
          >
            <Tab label="เงื่อนไข" {...a11yProps(0)} />
            <Tab
              label={props.from === "CSSALE" ? "ลูกหนี้" : "เลือกเจ้าหนี้"}
              {...a11yProps(1)}
            />
            <Tab label="สินค้า" {...a11yProps(2)} />
          </Tabs>{" "}
          {/*    */}
          <TabPanel value={tabValue} index={0}>
            {props.from === "CSSALE" ? (
              <ConditionAR
                result={(e) => resultCondition("tab1", e)}
                defaultValue={tabData1}
              />
            ) : (
              <ConditionAP
                result={(e) => resultCondition("tab1", e)}
                defaultValue={tabData1}
              />
            )}
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            {props.from === "CSSALE" ? (
              <ConditionARSelect
                result={(e) => resultCondition("tab2", e)}
                defaultValue={tabData2}
              />
            ) : (
              <ConditionAPSelect
                result={(e) => resultCondition("tab2", e)}
                defaultValue={tabData2}
              />
            )}
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            <ConditionSelectProduct
              result={(e) => resultCondition("tab3", e)}
              defaultValue={tabData3}
            />
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
